var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-num"},[_vm._m(0),_c('div',{staticClass:"num"},_vm._l((_vm.numArray),function(item,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v(" 区域内视频报警总数 "),_c('img',{attrs:{"src":require("@/assets/img/eduBigData/time-bg.png"),"alt":""}})])
}]

export { render, staticRenderFns }